export default __webpack_public_path__ + "static/media/open-purchase-orders.9a995f1b.svg";